<template>
  <v-flex xs12 sm12 md12>

    <v-text-field   hide-details="" :tabindex="tabdeger" v-model="displayValue" :disabled="Boolean(aktif)" :label="etiket"
      :name="name"  @blur="test()" :id="id" @focus="isInputActive=true" :reverse="Boolean(reverse)">
    </v-text-field>

  </v-flex>


</template>

<script>
  export default {
    name: 'currency-input',
    data() {
      return {
        isInputActive: false
      }
    },
    // `hane`: gosterilecek ondalik basamak sayisi. Verilmezse 2 --
    // mevcut tum kullanimlar aynen kaliyor. Birim fiyat alani 4 veriyor
    // (veritabanindaki money sutunu 4 hane tutuyor).
    props: ['value', 'tabindex', 'name', 'id', 'etiket', 'aktif', 'tabdeger','simge','rules','isPositive','reverse','hane'],
     computed: {
      displayValue: {
        get: function () {
        //  this.value = parseFloat(this.value)
          if (typeof (this.value) != 'number') {
            return 0
          }
          // eslint-disable-next-line no-empty
          if(typeof(this.simge) == 'undefined'){
     
          }
          if (this.isInputActive) {
            return this.value.toString()
          } else {
            var basamak = (typeof this.hane === 'undefined' || this.hane === null) ? 2 : parseInt(this.hane, 10);
            // Binlik ayirici YALNIZCA tam kisma uygulanir. Eski ifade tum
            // metin uzerinde calisiyordu ve ondalik 3 haneden uzun olunca
            // son uc haneyi binlik grubu saniyordu: 12,3456 -> "12.3,456".
            // 2 hanede gorulmuyordu, 4 haneye cikinca ortaya cikti.
            var parcalar = this.value.toFixed(basamak).split('.');
            parcalar[0] = parcalar[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            var result = parcalar.join('.') + this.simge;
            if(this.isPositive){
                var controlMinus = result.search('-');
                  if(controlMinus == 0){
                    this.$emit('input',0);
                    return 0;
                  }
            }
            
            return result;
          }

        },
        set: function (modifiedValue) {
          let newValue = parseFloat(modifiedValue)
          if (isNaN(newValue)) {
            newValue = 0
          }
          this.$emit('input', parseFloat(newValue))
        }
      },
      
    },
    methods: {
        test(){
    this.isInputActive=false
    this.$emit('odakkaybi', this.value)
    },
      getsifir() {
        return 0;
      }
    }
  }
</script>

<style scoped>
</style>